module.exports = __webpack_public_path__ + "static/media/carbon.75019c01.png";